import escape from 'lodash/escape';
import forOwn from 'lodash/forOwn';
import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import size from 'lodash/size';
import jQuery from 'jquery';
import Vue from 'vue';
import EventService from '../common/event/EventService';
import translate from '../common/localization/translate';
import VcomProvider from '../VcomProvider';
import SystemListEvent from './events/SystemListEvent';
import Base from './Base';
import PopperFactory from '../common/popper/PopperFactory';
import SystemFilterEvent from './events/SystemFilterEvent';
import SystemFilter from '../common/systemFilter/const/SystemFilter';
import SystemFilterService from '../common/systemFilter/SystemFilterService';
import BootstrapVariant from '../vendor/bootstrap/BootstrapVariant';
import AlertMessage from '../common/layout/AlertMessage.vue';

export default function Sidebar() {
  const statusRanges = [
    0,
    25,
    50,
    75,
    100,
    200,
    250,
  ];
  const statusTitles = {};
  const communicationStatusTitles = {};
  const systemListMaxHoverAmount = 4000;
  let hasEvaluationAccess;
  let systemListContent;
  let systemcount;

  function makeAlarmStatusClass(status) {
    return `status-alarm status-icon status-color-${status} icomoon icon-bell2`;
  }

  function makeCommunicationStatusClass(status) {
    return `status-data-input status-icon status-color-${status} icomoon icon-database-time2`;
  }

  function makeStatusIcons(system) {
    if (Object.prototype.hasOwnProperty.call(system, 'status')) {
      const statusClass = makeAlarmStatusClass(system.status);
      const communicationStatusClass = makeCommunicationStatusClass(system.statusDateneingang);
      return (
        `<div class="${statusClass}" title="${statusTitles[system.status]}"></div>
           <div class="${communicationStatusClass}" title="${communicationStatusTitles[system.statusDateneingang]}"></div>`
      );
    }
    return '';
  }

  function appendRow(system) {
    const title = translate('javascript.SYSTEM_KEY');
    const statusIcons = makeStatusIcons(system);
    const escapedSystemName = escape(system.label);
    const systemName = `<div class="system-name flex-grow-1 truncate">${escapedSystemName}</div>`;
    return (
      `<li class="d-flex clickable" 
             id="anlagenlisteAnlage_${system.id}" 
             title="${title}: ${system.key}, ${escapedSystemName}">
          ${statusIcons}
          ${systemName}
        </li>`
    );
  }

  function writeDom(systemList) {
    systemcount = size(systemList);
    if (systemcount > systemListMaxHoverAmount) {
      Vue.customElement('alert-message', AlertMessage);
      const alertMessage = window.document.querySelector('#sidebar alert-message');
      if (alertMessage === null) {
        window.document
          .querySelector('.sidebar__content')
          .insertAdjacentHTML(
            'beforebegin',
            `<alert-message message="${translate('javascript.SYSTEM_LIST_USE_RIGHT_CLICK')}" alert-class="mb-2" variant="${BootstrapVariant.WARNING}"></alert-message>`,
          );
      }
    } else {
      const alertMessage = window.document.querySelector('#sidebar alert-message');
      if (alertMessage !== null) {
        alertMessage.remove();
      }
    }

    jQuery('#anlagenfilterSummaryCount').text(systemcount);
    jQuery('#anlagenfilterSummaryCapacity').text(VcomProvider.installedCapacity);
    if (isEmpty(systemList)) {
      systemListContent.html(
        `<div class="mt-3">${translate('default.SYSTEM_FILTER_NO_RESULT')}</div>`,
      );
      return;
    }
    const systems = Base.sortSystems(systemList);
    const rows = systems.map(appendRow).join('');
    const list = `<ul class="h-100 system-list mr-2">${rows}</ul>`;
    systemListContent.html(list);
  }

  function makeCockpitLink(system) {
    const hrefCockpit = `${VcomProvider.baseUrl}/default/cockpit/index/systemId/${system.id}`;
    const cockpitIcon = '<span class="jump-to-links__link-icon icomoon icon-circle-right4"></span>';
    const title = translate('javascript.TX_TO_COCKPIT');
    return (
      `<a href="${hrefCockpit}" 
            title="${title}"
            class="jump-to-links__link">${cockpitIcon}</a>`
    );
  }

  function makeEvaluationLink(system) {
    if (hasEvaluationAccess === false) {
      return '';
    }
    const hrefEvaluation = `${VcomProvider.baseUrl}/evaluation/index/index/systemId/${system.id}`;
    const evaluationIcon = '<span class="jump-to-links__link-icon icomoon icon-stats-dots"></span>';
    const title = translate('javascript.TX_GOTO_EVALUATION');
    return (
      `<a href="${hrefEvaluation}"
            title="${title}"
            class="jump-to-links__link">${evaluationIcon}</a>`
    );
  }

  function makeAdministrationLink(system) {
    if (VcomProvider.hasSystemConfigRights === false) {
      return '';
    }
    const administrationIcon = '<span class="jump-to-links__link-icon icomoon icon-wrench"></span>';
    const title = translate('javascript.TX_TO_SYSTEM_CONFIG');
    return (
      `<a title="${title}"
            class="administration-control admin-system-id jump-to-links__link clickable"
            system-id="${system.id}">${administrationIcon}</a>`
    );
  }

  function makeJumpToLinks(system) {
    const cockpitLink = makeCockpitLink(system);
    const evaluationLink = makeEvaluationLink(system);
    const administrationLink = makeAdministrationLink(system);
    return (
      `<div class="jump-to-links-container">
          ${cockpitLink}${evaluationLink}${administrationLink}
        </div>`
    );
  }

  function openSidebar() {
    const shouldOpenSidebar = ['open', null].includes(localStorage.getItem('sidebar'));
    if (shouldOpenSidebar && jQuery('#content.sidebar-hidden').length) {
      jQuery('#sidebar-toggle').trigger('click');
    }
  }

  function buildSidebar(systemList) {
    writeDom(systemList);

    const systems = jQuery('.sidebar__content li');
    const sidebarContextMenuElement = document.getElementById('sidebar-context-menu');

    systems.on('contextmenu', (e) => {
      e.preventDefault();
      const popperOptions = {
        placement: 'top-end',
        modifiers: {
          offset: {
            offset: `-${e.currentTarget.offsetWidth - e.pageX}px, -130px`,
          },
        },
      };
      PopperFactory.make(e.currentTarget, sidebarContextMenuElement, popperOptions);
      EventService.dispatch('showSidebarContextMenu', { data: e });
    });

    systemListContent.unmask();
  }

  function highlightActiveSystem() {
    if (typeof VcomProvider.systemId === 'undefined') {
      return;
    }

    const systemListElement = jQuery(`#anlagenlisteAnlage_${VcomProvider.systemId}`);
    if (systemListElement.length === 0) {
      return;
    }

    systemListElement.addClass('activeRow ui-state-highlight mc-state-inline-highlight');
    const sidebarContent = jQuery('#sidebar .sidebar__content');
    sidebarContent.scrollTop(systemListElement.position().top - sidebarContent.position().top);
  }

  function refreshSidebar() {
    systemListContent.mask({ timeout: 30000 });
    Base.getSystems({}).done((systems) => {
      buildSidebar(systems);
      highlightActiveSystem();
    });
  }

  function getSystemId() {
    return window.location.pathname.split('systemId/')[1];
  }

  function bindSystemListEvents() {
    EventService.addListener(SystemFilterEvent.TEXT_CHANGED, {
      callback: (event) => {
        const { filter } = event.detail;
        const term = filter.toLowerCase();
        Base.getSystems().done((systems) => {
          const systemList = pickBy(systems, ({ label, key }) => label.toLowerCase().includes(term)
            || term === key.toLowerCase());
          buildSidebar(systemList);
          highlightActiveSystem();
        });
      },
    });

    EventService.addListener(SystemFilterEvent.SELECTION_CHANGED, {
      callback: async (event) => {
        const { filters } = event.detail;
        if (filters.length === 0) {
          await SystemFilterService.resetSystemFilters();
        }
        const unlicensedSystemFilter = SystemFilter.UNLICENSED_SYSTEMS.ID_SAF_TF_TEILMENGE;
        const previousFilterWasUnlicensedSystemFilter = VcomProvider.systemFilters.some(
          (filter) => filter.ID_SAF_TF_TEILMENGE === unlicensedSystemFilter,
        );
        const filtersHasUnlicensedSystemFilter = filters.some(
          (filter) => filter.ID_SAF_TF_TEILMENGE === unlicensedSystemFilter,
        );
        systemListContent.mask({ timeout: 30000 });
        Base.getSystems({ anlagenfilter: filters }).done((systems) => {
          EventService.dispatch(SystemListEvent.FILTER_CHANGED);
          buildSidebar(systems);
          highlightActiveSystem();
          if (previousFilterWasUnlicensedSystemFilter || filtersHasUnlicensedSystemFilter) {
            window.location.reload(true);
          }
        });
      },
    });

    systemListContent.on('click', 'li', (event) => {
      const target = jQuery(event.target);

      if (target.hasClass('jump-to-links__link-icon')
        || target.hasClass('jump-to-links__link')) {
        return true;
      }

      const clickedSystemId = Number(jQuery(event.currentTarget).attr('id').split('_')[1]);
      if (getSystemId()) {
        window.location.href = `${VcomProvider.baseUrl}/default/index/jump/systemId/${clickedSystemId}`;
        return false;
      }
      const row = jQuery(event.currentTarget);
      const bezeichnung = row.text().trim();
      const unlicensedFilterId = SystemFilter.UNLICENSED_SYSTEMS.ID_SAF_TF_TEILMENGE;
      if (row.hasClass('activeRow')) {
        row.removeClass('activeRow ui-state-highlight mc-state-inline-highlight');
        VcomProvider.systemId = null;
        EventService.dispatch(SystemListEvent.SYSTEM_DESELECTED);
      } else if (!VcomProvider.systemFilters.some(
        (filter) => filter.ID_SAF_TF_TEILMENGE === unlicensedFilterId,
      )) {
        EventService.dispatch(
          SystemListEvent.SYSTEM_SELECTED,
          {
            data: {
              id: clickedSystemId,
              systemName: bezeichnung,
            },
          },
        );
      }
      return true;
    });

    systemListContent.on('mouseenter', 'li', (event) => {
      if (systemcount < systemListMaxHoverAmount) {
        const id = jQuery(event.currentTarget).attr('id');
        const systemId = Number(id.replace('anlagenlisteAnlage_', ''));
        jQuery(event.currentTarget).append(makeJumpToLinks({ id: systemId }));
      }
    });

    systemListContent.on('mouseleave', 'li', (event) => {
      if (systemcount < systemListMaxHoverAmount) {
        jQuery(event.currentTarget).find('.jump-to-links-container').remove();
      }
    });

    EventService.addListener(SystemListEvent.SYSTEM_SELECTED, {
      callback(event) {
        VcomProvider.systemId = event.detail.id;
        const row = jQuery(`li#anlagenlisteAnlage_${event.detail.id}`);
        if (!row.hasClass('activeRow')) {
          row.siblings().removeClass('activeRow ui-state-highlight mc-state-inline-highlight');
          row.addClass('activeRow ui-state-highlight mc-state-inline-highlight');
        }
      },
    });
    refreshSidebar();
  }

  function refreshStatus(anlagenStatus) {
    if (isEmpty(anlagenStatus)) {
      return;
    }
    const systemList = systemListContent[0].querySelector('.system-list');
    if (systemList === null) {
      return;
    }
    forOwn(
      anlagenStatus,
      ({ status: alarmStatus, statusDateneingang: communicationStatus, id: systemId }) => {
        const statusContainer = systemList.querySelector(`#anlagenlisteAnlage_${systemId}`);
        if (statusContainer === null) {
          return;
        }

        const alarmStatusElement = statusContainer.querySelector('.status-alarm');
        if (alarmStatusElement !== null) {
          alarmStatusElement.className = makeAlarmStatusClass(alarmStatus);
          alarmStatusElement.title = statusTitles[alarmStatus];
        }
        const communicationStatusElement = statusContainer.querySelector('.status-data-input');
        if (communicationStatusElement !== null) {
          communicationStatusElement.className = makeCommunicationStatusClass(communicationStatus);
          communicationStatusElement.title = communicationStatusTitles[communicationStatus];
        }
      },
    );
  }

  function initStatusTitles() {
    statusRanges.forEach((status) => {
      statusTitles[status] = translate(`javascript.TX_ALARMSTATUS_${status}`);
    });
  }

  function initCommunicationStatusTitles() {
    statusRanges.forEach((status) => {
      communicationStatusTitles[status] = translate(`javascript.TX_DATAINPUT_${status}`);
    });
  }

  return {
    init(accessRights) {
      hasEvaluationAccess = accessRights;
      systemListContent = jQuery('#sidebar .sidebar__content');

      initStatusTitles();
      initCommunicationStatusTitles();
      bindSystemListEvents();
      EventService.addListener(SystemListEvent.CHANGED, {
        callback(event) {
          refreshStatus(event.detail.systemList);
          systemListContent.unmask();
        },
      });

      jQuery('#sidebar-toggle').on('click', () => {
        const $sidebar = jQuery('#sidebar');
        const $sidebarToggle = jQuery('#sidebar-toggle');
        const $sidebarToggleIcon = jQuery('#sidebar-toggle-icon');

        const position = $sidebar.position();

        if (position.left === 0) {
          $sidebar.css('left', -250);
          jQuery('#content').addClass('sidebar-hidden');
          $sidebarToggle.css('width', 'initial');
          $sidebarToggleIcon.addClass('icon-arrow-right2');
          $sidebarToggleIcon.removeClass('icon-arrow-left2');
          localStorage.setItem('sidebar', 'close');
        } else {
          $sidebar.css('left', 0);
          $sidebarToggle.css('width', 250);
          $sidebarToggleIcon.addClass('icon-arrow-left2');
          $sidebarToggleIcon.removeClass('icon-arrow-right2');
          jQuery('#content').removeClass('sidebar-hidden');
          $sidebar.find('.systemName').css('width', '187px');
          localStorage.setItem('sidebar', 'open');
        }
        VcomProvider.Layout.resize();
      });
      openSidebar();
    },
    refreshSidebar,
  };
}
